React = require 'react'
{ Component, PropTypes } = React
{ connect } = require 'react-redux'
InProgressObservationsComponent = require '../components/InProgressObservations'
{ inProgress } = require '../api/observations'
LoadingSpinner = require '../../../shared/js/components/LoadingSpinner'
{ Button } = require 'react-bootstrap'

class InProgressObservationsContainer extends Component
	state:
		fetchData: null
		fetchError: null
		isFetching: false

	componentDidMount: =>
		@fetch()

	fetch: =>
		@setState isFetching: true

		@props.inProgress()
		.then (response) =>
			@setState fetchData: response.data.list
		.catch (error) =>
			@setState fetchError: error
		.then =>
			@setState isFetching: false

	render: =>
		{ isFetching, fetchData, fetchError } = @state

		if fetchError
			React.createElement("div", {"className": "container fill-parent"},
				React.createElement("div", {"className": "error"}, """
\t\t\t\t\tThere was an error fetching data for this observation session: """, (fetchError.message)
				)
			)
		else if isFetching || !fetchData
			React.createElement("div", {"className": "container fill-parent"},
				React.createElement("div", {"className": "fetching"}, """
\t\t\t\t\tLoading observation data... """, React.createElement(LoadingSpinner, null)
				)
			)
		else
			React.createElement(InProgressObservationsComponent, { \
				"observations": (fetchData)
			})

mapStateToProps = (state) ->
	return {}

mapDispatchToProps = {
	inProgress
}
module.exports = connect(mapStateToProps, mapDispatchToProps)(InProgressObservationsContainer)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/InProgressObservations.cjsx